import React, { FC } from 'react';
import { searchConstants } from '../../../../search-utils/searchConstants';
import { DatesSelectors } from './DatesSelectors';
import { CommonSection } from '../../CommonSection';

export const Dates: FC = () => {
  return (
    <CommonSection title={searchConstants.filters.dates}>
      <DatesSelectors />
    </CommonSection>
  );
};
